export default __webpack_public_path__ + "e93bcb76a74fcf377d99cb7f52da1ea7.svg";